import { useState, useEffect, type Dispatch, type SetStateAction } from "react";

import type { NavGroup } from "./navDrawer.types";

type GroupExpandedState = Partial<Record<NavGroup["id"], boolean>>;

export function useSideNavSubmenuAutoExpand(
  pathname: string,
  enabled: boolean
): [GroupExpandedState, Dispatch<SetStateAction<GroupExpandedState>>] {
  const [groupExpanded, setGroupExpanded] = useState<GroupExpandedState>({});

  useEffect(() => {
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
    if (!enabled) return;
    if (pathname === "/settings" || pathname.startsWith("/settings/")) {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
      setGroupExpanded((prev) => ({
        ...prev,
        settings: true,
        serviceSupport: false
      }));
    } else if (
      pathname === "/service-support" ||
      pathname.startsWith("/service-support/")
    ) {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
      setGroupExpanded((prev) => ({
        ...prev,
        serviceSupport: true,
        settings: false
      }));
    } else {
      // Collapse nav groups when leaving settings / service-support for a flat link.
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
      setGroupExpanded((prev) => ({
        ...prev,
        settings: false,
        serviceSupport: false
      }));
    }
  }, [enabled, pathname]);

  return [groupExpanded, setGroupExpanded];
}
